module.exports = "/images/0b9031f82b6fdd67a8a52b06dff114f7.png";